<template>
  <div>
    <es-loader
      v-if="loadingSavedData"
      style="margin-top: 3rem"
    />
    <template v-else>
        <es-form>
        <template #es-form-header style="margin: 0">
          <div class="header-container">
            <div class="header-elements">
              <font-awesome-icon :icon="['fas', 'search']" size="lg"/>
            </div>
            <div class="header-elements">
              <h6 class="title is-6">
                Search Settings
              </h6>
            </div>
          </div>
        </template>
        <template #es-form>
          <div class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Search In
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="buttons has-addons">
                      <button
                        v-for="(option, index) in searchInOptions"
                        :key="index"
                        class="button button--form"
                        :class="{ 'is-active': selectedSearchInOption === option.label }"
                        @click="checkSearchInOption(option.label)"
                        style="min-width: 100px"
                      >
                        {{ option.label }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isMaster"
            class="row removeUnderline"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  School Year
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <es-select
                      valueTpl="${year}"
                      keyValue="id"
                      v-on:update:values="schoolYearInput = $event
                      appendWildCard('schoolYear')"
                      ref="selYears"
                      :setValues="pidSchoolYearsDesc"
                      :clearOut="true"
                      :preSelected="schoolYearInput"
                      :hasError="hasErrorSchoolYear"

                    />
                  </div>
                  <span v-if="hasErrorSchoolYear" class="help is-danger">
                    {{ msgSchoolYear }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Match Method
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="buttons has-addons">
                      <button
                        v-for="(option, index) in matchMethodsDisplayed"
                        :key="index"
                        class="button button--form"
                        :class="{ 'is-active': selectedMatchMethod === option.label }"
                        @click="checkMatchMethod(option.label)"
                        :style="matchMethodWidth"
                      >
                        {{ option.label }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="contextMode" class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Person Type
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="buttons has-addons">
                      <button
                        v-for="(option, index) in sortedPersonTypesOptions"
                        :key="index"
                        class="button button--form"
                        :class="{ 'is-active': personType === option.code }"
                        @click="personType = option.code"
                        :disabled="!enabledSubmissionStatus.includes(option.code)
                          && option.code !== null"
                        style="min-width: 100px"
                      >
                        {{ option.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isMatchingEngine && !contextMode" class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  Search Rule
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="buttons has-addons">
                      <button
                        v-for="(option, index) in sortedPersonTypesOptions"
                        :key="index"
                        class="button button--form"
                        :class="{ 'is-active': personType === option.code }"
                        @click="personType = option.code"
                        :disabled="!enabledSubmissionStatus.includes(option.code)
                          && option.code !== null"
                        style="min-width: 100px"
                      >
                        {{ option.name }} Rule
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </es-form>
    <!-- Person Information -->
    <es-form>
      <template #es-form-header style="margin: 0">
        <div class="header-container">
          <div class="header-elements">
            <font-awesome-icon :icon="['fas', 'user']"/>
          </div>
          <div class="header-elements">
            <h6 class="title is-6">
              Person Information
            </h6>
          </div>
        </div>
      </template>
      <template #es-form>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="personType === null">
                  {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:FIRST_NAME`) }}
                </span>
                <span v-else>
                  {{ getFieldLabel(`PER:${personType}:SEARCH:FIRST_NAME`) }}
                </span>
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger' : hasErrorFName}"
                    type="text"
                    v-model="fName"
                    @keyup.prevent="appendWildCard('fName')"
                    :aria-label="getFieldLabel(`PER:${personType}:SEARCH:FIRST_NAME`)"
                  >
                </div>
                <span v-if="hasErrorFName" class="help is-danger">
                  {{ msgFName }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="personType === null">
                    {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:MIDDLE_NAME`) }}
                  </span>
                  <span v-else>
                  {{ getFieldLabel(`PER:${personType}:SEARCH:MIDDLE_NAME`) }}
                  </span>
                <span class="label-optional has-text-grey-light">
                  &nbsp;(optional)
                </span>
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input
                    class="input"
                    :class="{ 'is-danger': hasErrorMName }"
                    type="text"
                    v-model="mName"
                    @keyup.prevent="appendWildCard('mName')"
                    :aria-label="getFieldLabel(`PER:${personType}:SEARCH:MIDDLE_NAME`)"
                  >
                </div>
                <span v-if="hasErrorMName" class="help is-danger">
                    {{ msgMName }}
                  </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="personType === null">
                  {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:LAST_NAME`) }}
                </span>
                <span v-else>
                  {{ getFieldLabel(`PER:${personType}:SEARCH:LAST_NAME`) }}
                </span>
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger' : hasErrorLName}"
                    type="text"
                    v-model="lName"
                    @keyup.prevent="appendWildCard('lName')"
                    :aria-label="getFieldLabel(`PER:${personType}:SEARCH:LAST_NAME`)"
                  >
                </div>
                <span v-if="hasErrorLName" class="help is-danger">
                  {{ msgLName }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="personType === null">
                  {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:SUFFIX`) }}
                </span>
                <span v-else>
                  {{ getFieldLabel(`PER:${personType}:SEARCH:SUFFIX`) }}
                </span>
                <span class="label-optional has-text-grey-light">
                     &nbsp;(optional)
                  </span>
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input
                    class="input"
                    :class="{ 'is-danger': hasErrorSuffix }"
                    type="text"
                    v-model="suffix"
                    @keyup.prevent="appendWildCard('suffix')"
                    :aria-label="getFieldLabel(`PER:${personType}:SEARCH:SUFFIX`)"
                  >
                </div>
                <span v-if="hasErrorSuffix" class="help is-danger">
                    {{ msgSuffix }}
                  </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="personType === null">
                  {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:DATE_OF_BIRTH`) }}
                </span>
                <span v-else>
                  {{ getFieldLabel(`PER:${personType}:SEARCH:DATE_OF_BIRTH`) }}
                </span>
                <span class="label-optional has-text-grey-light">
                   &nbsp;(optional)
                </span>
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <input
                      class="input calendar"
                      :class="{'is-danger' : hasErrorDateOfBirth}"
                      type="date"
                      v-model="dob"
                      @keyup.prevent="appendWildCard('dob')"
                      @paste.prevent="onPasteDate"
                      :aria-label="getFieldLabel(`PER:${personType}:SEARCH:DATE_OF_BIRTH`)"
                    />
                  </div>
                   <span v-if="hasErrorDateOfBirth" class="help is-danger">
                              {{ msgDateOfBirth }}
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="personType === null">
                  {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:GENDER_CODE`) }}
                </span>
                <span v-else>
                {{ getFieldLabel(`PER:${personType}:SEARCH:GENDER_CODE`) }}
                </span>
                <span class="label-optional has-text-grey-light">
                  &nbsp;(optional)
                </span>
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-for="(option, index) in activeGenders"
                      :key="index"
                      class="button button--form"
                      :class="{ 'is-active': gender === option.code }"
                      @click="gender = option.code"
                      style="min-width: 100px"
                    >
                      {{ option.description }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- TODO: Feature to add later
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="personType === null">
                  {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:SOCIAL_SECURITY_NUMBER`) }}
                </span>
                <span v-else>
                  {{ getFieldLabel(`PER:${personType}:SEARCH:SOCIAL_SECURITY_NUMBER`) }}
                </span>
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="ssn"
                    @keyup.prevent="appendWildCard('ssn')"
                    :aria-label="getFieldLabel(`PER:${personType}:SEARCH:SOCIAL_SECURITY_NUMBER`)"
                  >
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </template>
    </es-form>
    <div
      class="is-flex flex-justify--end flex-align--center"
      style="margin-right: 5.15rem; padding-bottom: 2rem"
    >
      <button
        class="button button-link has-underline"
        @click="reset"
        style="margin-right: 1rem"
      >
        Reset
      </button>
      <button
        class="button is-primary"
        :disabled="loadingStudents"
        @click="search"
      >
        Search
      </button>
    </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  mapActions,
  mapGetters,
} from 'vuex';
import {
  faUser,
  faSearch,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsSelect from '@/components/EsSelect.vue';
import FieldLabels from '@/mixins/FieldLabels';
import DateUtils from '@/mixins/DateUtils';
import PermissionManager from '@/mixins/PermissionManager';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faUser,
  faSearch,
);

export default {
  mixins: [
    FieldLabels,
    DateUtils,
    PermissionManager,
    NotificationManager,
  ],
  components: {
    EsForm,
    EsLoader,
    EsSelect,
  },
  props: {
    page: {
      type: String,
    },
    sortField: {
      type: String,
      default: 'name',
    },
    sortOrder: {
      type: String,
      default: 'DESC',
    },
    loadingStudents: {
      type: Boolean,
    },
  },
  data() {
    return {
      allSubmissionSpecs: [],
      dob: null,
      fName: '',
      gender: null,
      lName: '',
      matchMethod: [],
      mName: '',
      schoolYearInput: [],
      searchInOptions: [],
      selectedMatchMethod: 'Matching Engine',
      selectedSearchInOption: 'Master',
      personType: null,
      suffix: '',
      // ssn:'',
      hasErrorFName: null,
      hasErrorMName: null,
      hasErrorLName: null,
      hasErrorSuffix: null,
      hasErrorSchoolYear: null,
      hasErrorDateOfBirth: null,
      loadingSavedData: false,
      msgFName: null,
      msgMName: null,
      msgLName: null,
      msgSuffix: null,
      msgSchoolYear: null,
      msgDateOfBirth: null,
      restoringSavedData: false,
      studentInfoCleaned: [],
      userPersonTypesCodes: null,
    };
  },
  created() {
    this.setDataElements();
  },
  async mounted() {
    this.loading = true;
    this.loadingError = false;
    try {
      await Promise.all([
        this.loadSources(),
        this.loadPersonTypes(),
        this.loadPidSchoolYears(),
        this.loadSources(),
      ]);
      this.sourceInput = this.defaultSource;
      this.userPersonTypesCodes = this.userPersonTypes
        .map(item => item.code);
      this.personType = this.userPersonTypesCodes.includes(this.defaultPersonType)
        ? this.defaultPersonType : this.userPersonTypesCodes[0];
      this.loadSubmissionSpecs();
      this.searchType = 'newSearch';

      // Auto-execute search if searchByPerson state exists in Vuex
      const saved = this.$store.getters['personSearchModule/getSearchByType']('searchByPerson');
      if (saved && Object.keys(saved).length > 0) {
        this.loadingSavedData = true;
        this.$emit('show', false);
        this.$emit('loadingSavedData', true);
        this.restoringSavedData = true;
        // Populate fields from saved state
        this.fName = saved.fName || '';
        this.mName = saved.mName || '';
        this.lName = saved.lName || '';
        this.dob = saved.dob || null;
        this.gender = saved.gender || null;
        this.suffix = saved.suffix || '';
        this.selectedMatchMethod = saved.selectedMatchMethod || 'Matching Engine';
        this.selectedSearchInOption = saved.selectedSearchInOption || 'Master';
        if (saved.personType) {
          this.personType = saved.personType;
        }
        // Wait for watchers triggered by selectedSearchInOption to settle.
        await this.$nextTick();
        if (saved.schoolYear && this.selectedSearchInOption !== 'Master') {
          const savedSchoolYear = String(saved.schoolYear);
          this.schoolYearInput = this.pidSchoolYearsDesc
            .filter(y => String(y.year) === savedSchoolYear);

          // Fallback keeps visible selected value when year list arrives late.
          if (!this.schoolYearInput.length) {
            this.schoolYearInput = [{ year: saved.schoolYear }];
          }
        }
        this.restoringSavedData = false;
        this.loadingSavedData = false;
        this.$emit('loadingSavedData', false);
        this.search({ saveState: false, pageNum: saved.pageNum || null });
      }
    } catch (err) {
      this.loadingError = true;
      this.messages.push('There were some errors. Please try again. If errors persist please contact support.');
      this.showNotification('danger', this.messages);
    } finally {
      this.loading = false;
    }
  },
  watch: {
    '$route.query.page': {
      handler(newPage) {
        const saved = this.$store.getters['personSearchModule/getSearchByType']('searchByPerson');
        if (saved && Object.keys(saved).length > 0) {
          this.$store.dispatch('personSearchModule/setSearchState', {
            searchType: 'searchByPerson',
            ...saved,
            pageNum: newPage ? Number(newPage) : null,
          });
        }
      },
    },
    isMaster() {
      if (this.restoringSavedData) {
        return;
      }
      if (this.isMaster) {
        this.selectedMatchMethod = 'Matching Engine';
        this.schoolYear = null;
      } else {
        this.setCurrentSchoolYear();
      }
    },
  },
  computed: {
    ...mapGetters(['userPersonTypes']),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('lookups', [
      'activeSources',
      'pidSchoolYearsDesc',
      'defaultPersonType',
      'activeGenders',
    ]),
    allSubSpecsArray() {
      return [].concat(...this.allSubmissionSpecs);
    },
    defaultSource() {
      if (this.activeSources) {
        const defaultType = this.activeSources
          .find(el => el.defaultType === true);
        return defaultType ? defaultType.code : this.activeSources[0].code;
      } return null;
    },
    enabledSubmissionStatus() {
      if (this.allSubSpecsArray) {
        return this.allSubSpecsArray
          .filter(d => d.purpose === 'SEARCH' && d.enabled === true)
          .map(p => p.personType.code);
      } return null;
    },
    futureBirthYearsAllowed() {
      return this.$store.state.propertiesModule.properties['RULE-FUTURE_BIRTH_YEARS'] !== 'false';
    },
    sortedPersonTypesOptions() {
      const sorted = this.userPersonTypes.map(p => ({
        code: p.code,
        name: p.name,
      }));
      return sorted.slice().sort((a, b) => {
        if (a.name.toUpperCase() < b.name.toUpperCase()) {
          return -1;
        }
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
          return 1;
        }
        return 0;
      });
    },
    contextMode() {
      const identityControl = this.properties['IDENTITY_CONTROL-LIFETIME_IDS'];
      return JSON.parse(identityControl.toString().toLowerCase()) === false;
    },
    isMaster() {
      if (this.selectedSearchInOption === 'Master') {
        return true;
      }
      return false;
    },
    isMatchingEngine() {
      if (this.selectedMatchMethod === 'Matching Engine') {
        return true;
      }
      return false;
    },
    matchMethodsDisplayed() {
      if (this.isMaster) {
        return this.matchMethod;
      }
      return this.matchMethod.filter(item => item.isHidden);
    },
    matchMethodWidth() {
      let width;
      if (this.isMaster) {
        width = '150px';
      } else {
        width = '100px';
      }
      return `min-width: ${width}`;
    },
  },

  methods: {
    ...mapActions('lookups', [
      'loadSources',
      'loadPersonTypes',
      'loadPidSchoolYears',
      'loadGenders',
    ]),
    appendWildCard(field) {
      if (field === 'fName') {
        if (this.fName === null || this.fName === '') {
          this.hasErrorFName = true;
          this.msgFName = `${this.getFieldLabel(`PER:${this.personType === null ? this.defaultPersonType : this.personType}:SEARCH:FIRST_NAME`)
          } is required `;
        } else if (this.fName.length > 150) {
          this.hasErrorFName = true;
          this.msgFName = `${this.getFieldLabel(`PER:${this.personType === null ? this.defaultPersonType : this.personType}:SEARCH:FIRST_NAME`)
          } must be less than 150 characters.`;
        } else {
          this.hasErrorLName = false;
          this.msgFName = null;
          if (this.fName.trim() === '') {
            this.fName = null;
          }
        }
      }
      if (field === 'mName') {
        if (this.mName.length > 150) {
          this.hasErrorMName = true;
          this.msgMName = `${this.getFieldLabel(`PER:${this.personType === null ? this.defaultPersonType : this.personType}:SEARCH:MIDDLE_NAME`)
          } must be less than 150 characters.`;
        } else {
          this.hasErrorMName = false;
          this.msgMName = null;
          if (this.mName.trim() === '') {
            this.mName = null;
          }
        }
      }
      if (field === 'lName') {
        if (this.lName === null || this.lName === '') {
          this.hasErrorLName = true;
          this.msgLName = `${this.getFieldLabel(`PER:${this.personType === null ? this.defaultPersonType : this.personType}:SEARCH:LAST_NAME`)
          } is required `;
        } else if (this.lName.length > 150) {
          this.hasErrorLName = true;
          this.msgLName = `${this.getFieldLabel(`PER:${this.personType === null ? this.defaultPersonType : this.personType}:SEARCH:LAST_NAME`)
          } must be less than 150 characters.`;
        } else {
          this.hasErrorLName = false;
          this.msgLName = null;
          if (this.lName.trim() === '') {
            this.lName = null;
          }
        }
      }
      if (field === 'suffix') {
        if (this.suffix.length > 150) {
          this.hasErrorSuffix = true;
          this.msgSuffix = `${this.getFieldLabel(`PER:${this.personType === null ? this.defaultPersonType : this.personType}:SEARCH:SUFFIX`)
          } must be less than 150 characters.`;
        } else {
          this.hasErrorSuffix = false;
          this.msgSuffix = null;
          if (this.suffix.trim() === '') {
            this.suffix = null;
          }
        }
      }
      if (field === 'schoolYear') {
        if (!this.isMaster && this.schoolYearInput.length === 0) {
          this.hasErrorSchoolYear = true;
          this.msgSchoolYear = `${this.getFieldLabel(`PER:${this.personType === null ? this.defaultPersonType : this.personType}:SEARCH:SCHOOL_YEAR`)} is required.`;
        } else {
          this.hasErrorSchoolYear = false;
          this.msgSchoolYear = null;
        }
      }
      if (field === 'dob') {
        const dobLabel = this.getFieldLabel(
          `PER:${this.personType === null ? this.defaultPersonType : this.personType}:SEARCH:DATE_OF_BIRTH`,
        );
        const format = 'YYYY-MM-DD';

        if (this.dob) {
          const isValid = this.futureBirthYearsAllowed
            ? this.isValidDOBWithfutureBirthYearsAllowed(this.dob, format)
            : this.isValidDOB(this.dob, format);

          this.hasErrorDateOfBirth = !isValid;
          this.msgDateOfBirth = isValid ? null : `${dobLabel} is invalid.`;
        } else {
          this.hasErrorDateOfBirth = false;
          this.msgDateOfBirth = null;
        }
      }
    },
    checkSearchInOption(selection) {
      if (this.selection !== 'Master') {
        this.selectedMatchMethod = 'SQL';
        this.selectedSearchInOption = selection;
      } else {
        this.selectedSearchInOption = selection;
      }
    },
    checkMatchMethod(selection) {
      this.selectedMatchMethod = selection;
    },
    checkRequiredFields() {
      try {
        // Define an array to store errors
        const errors = [];

        // Helper function to check if a field is empty and update error state
        const checkField = (field, errorProp, msgProp, labelKey) => {
          if (this[field] === null || this[field] === '') {
            this[errorProp] = true;
            this[msgProp] = `${this.getFieldLabel(labelKey)} is required.`;
            errors.push(labelKey);
          } else {
            this[errorProp] = false;
            this[msgProp] = null;
          }
        };

        const personType = this.personType === null ? this.defaultPersonType : this.personType;

        // Check each required field
        checkField('fName', 'hasErrorFName', 'msgFName', `PER:${personType}:SEARCH:FIRST_NAME`);
        checkField('lName', 'hasErrorLName', 'msgLName', `PER:${personType}:SEARCH:LAST_NAME`);
        if (!this.isMaster && this.schoolYearInput.length === 0) {
          this.hasErrorSchoolYear = true;
          this.msgSchoolYear = `${this.getFieldLabel(`PER:${personType}:SEARCH:SCHOOL_YEAR`)} is required.`;
          errors.push(`PER:${personType}:SEARCH:SCHOOL_YEAR`);
        } else {
          this.hasErrorSchoolYear = false;
          this.msgSchoolYear = null;
        }

        // Show notification if there are any errors
        if (errors.length > 0) {
          this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
        }
      } catch (error) {
        // Reset all error states and messages in case of an exception
        this.hasErrorFName = false;
        this.hasErrorLName = false;
        this.hasErrorSchoolYear = false;
        this.hasErrorDateOfBirth = false;
        this.msgFName = null;
        this.msgLName = null;
        this.msgSchoolYear = null;
        this.msgDateOfBirth = null;
        this.resetNotifications();
      }

      // Return error states
      return [
        this.hasErrorFName,
        this.hasErrorLName,
        this.hasErrorMName,
        this.hasErrorSuffix,
        this.hasErrorSchoolYear,
        this.hasErrorDateOfBirth,
      ];
    },
    flatten(obj) {
      const flattenedObject = {};
      this.traverseAndFlatten(obj, flattenedObject);
      return flattenedObject;
    },
    async loadSubmissionSpecs() {
      const personTypeIds = this.userPersonTypes.map(item => item.id);
      try {
        this.loading = true;
        this.loadingError = false;
        // build promises to get submission specs info per person type
        const submissionSpecResponse = await Promise.all([...personTypeIds]
          .map(id => axios.get(`person-types/${id}/submission-specs/`)));
        // use the response from above and push them
        submissionSpecResponse.forEach((s) => {
          this.allSubmissionSpecs.push(s.data);
        });
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    async search({ saveState = true, pageNum = null } = {}) {
      const errors = this.checkRequiredFields();
      if (errors.includes(true)) {
        return;
      }
      const { query } = this.$route;
      query.fName = this.fName;
      query.mName = this.mName;
      query.lName = this.lName;
      query.suffix = this.suffix;
      query.dob = this.dob;
      query.gender = this.gender;
      if (this.isMaster === false) {
        query.schoolYearInput = this.schoolYearInput[0].year;
      }
      this.$router.push(
        {
          name: 'PidSearchPerson',
          query: {
            searchType: this.selectedSearchInOption,
            MatchMethod: this.selectedMatchMethod,
            personType: this.personType !== null ? this.personType : undefined,
            page: pageNum || undefined,
          },
        },
      );
      if (this.isMaster === false) {
        const schoolYear = this.schoolYearInput[0].year;
        this.$router.push({
          query: { ...this.$route.query, schoolYear, page: pageNum || undefined },
        });
      }
      if (saveState) {
        // Save search state to Vuex only for user-initiated searches.
        this.$store.dispatch('personSearchModule/setSearchState', {
          searchType: 'searchByPerson',
          fName: this.fName,
          mName: this.mName,
          lName: this.lName,
          dob: this.dob,
          gender: this.gender,
          suffix: this.suffix,
          selectedMatchMethod: this.selectedMatchMethod,
          selectedSearchInOption: this.selectedSearchInOption,
          personType: this.personType,
          schoolYear: this.isMaster === false && this.schoolYearInput.length
            ? this.schoolYearInput[0].year : null,
        });
      }
      this.searchParams();
      this.$emit('show', false);
    },
    searchParams() {
      const params = {};
      params.firstName = this.fName;
      params.middleName = this.mName !== null && this.mName.trim().length > 0
        ? this.mName : undefined;
      params.lastName = this.lName;
      params.suffix = this.suffix !== null && this.suffix.trim().length > 0
        ? this.suffix : undefined;
      params.dateOfBirth = this.dob ? this.dob : undefined;
      if (!this.contextMode) {
        params.personType = this.isMatchingEngine === true ? this.personType : undefined;
      } else {
        params.personType = this.personType !== null ? this.personType : undefined;
      }
      params.gender = this.gender !== null ? this.gender : undefined;
      // params.ssn = this.ssn !== null &&  this.ssn.trim().length > 0 ? this.ssn : undefined;
      if (this.isMaster === false) {
        params.schoolYearInput = this.schoolYearInput.length
          ? this.schoolYearInput[0].year : undefined;
      }
      params.selectedMatchMethod = this.selectedMatchMethod;
      params.selectedSearchInOption = this.selectedSearchInOption;
      this.$emit('searchParams', params);
      return params;
    },
    updateSorter() {
      this.$router.replace({ query: this.searchParams });
    },
    reset() {
      this.fName = '';
      this.mName = '';
      this.lName = '';
      this.dob = null;
      this.suffix = '';
      this.gender = null;
      // this.ssn = '';
      this.selectedMatchMethod = 'Matching Engine';
      this.selectedSearchInOption = 'Master';
      this.personType = this.userPersonTypesCodes.includes(this.defaultPersonType)
        ? this.defaultPersonType : this.userPersonTypesCodes[0];
      this.schoolYearInput = this.pidSchoolYearsDesc
        .filter(y => ((this.$store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'])
          .split()).find(sy => sy === y.year));
      this.hasErrorFName = false;
      this.hasErrorMName = false;
      this.hasErrorLName = false;
      this.hasErrorSuffix = false;
      this.hasErrorSchoolYear = false;
      this.hasErrorDateOfBirth = false;
      this.msgFName = null;
      this.msgMName = null;
      this.msgLName = null;
      this.msgSuffix = null;
      this.msgSchoolYear = null;
      this.msgDateOfBirth = null;
      this.resetNotifications();
      this.$store.dispatch('personSearchModule/resetSearchState', 'searchByPerson');
      this.searchParams();
      this.$emit('show', true);
      this.$router.replace({ query: {} }).catch(() => {});
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    setCurrentSchoolYear() {
      this.schoolYearInput = this.pidSchoolYearsDesc
        .filter(y => ((this.$store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'])
          .split()).find(sy => sy === y.year));
    },
    setDataElements() {
      this.searchInOptions = [];
      if (this.hasModule('PRSID:SRCH:OPTIONS:PRSN:SRCH')) {
        this.searchInOptions.push({ label: 'Master' });
      }
      if (this.hasModule('PRSID:SRCH:OPTIONS:HIST:SRCH')) {
        this.searchInOptions.push({ label: 'History' });
      }
      if (this.hasModule('PRSID:SRCH:OPTIONS:INPUTREC:SRCH')) {
        this.searchInOptions.push({ label: 'Submission' });
      }
      this.allPersonType = [
        {
          code: null,
          name: 'All',
        },
      ];
      this.matchMethod = [
        {
          label: 'Matching Engine',
          isHidden: false,
        },
        {
          label: 'SQL',
          isHidden: true,
        },
      ];
      this.setCurrentSchoolYear();
      this.userPersonTypesCodes = this.userPersonTypes
        .map(item => item.code);
      this.personType = this.userPersonTypesCodes.includes(this.defaultPersonType)
        ? this.defaultPersonType : this.userPersonTypesCodes[0];
    },
    traverseAndFlatten(currentNode, target, flattenedKey) {
      Object.keys(currentNode).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(currentNode, key)) {
          let newKey;
          if (flattenedKey === undefined) {
            newKey = key;
          } else {
            newKey = `${flattenedKey}_${key}`;
          }
          const value = currentNode[key];
          if (typeof value === 'object') {
            this.traverseAndFlatten(value, target, newKey);
          } else {
            target[newKey] = value; // eslint-disable-line no-param-reassign
          }
        }
      });
    },
    onPasteDate(evt) {
      const data = evt.clipboardData.getData('text').trim();
      const date = new Date(data);

      if (Number.isNaN(date.getTime())) {
        return;
      }

      // Format to YYYY-MM-DD
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      this.dob = `${year}-${month}-${day}`;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
